
import Vue, { PropType } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import { Device } from '@/interfaces/locations';

export default Vue.extend({
	components: {
		Modal,
	},
	props: {
		gateway: { type: Object as PropType<Device> },
	},

	methods: {
		closeModal(): void {
			this.$bvModal.hide('modal-decommission-gateway');
		},

		confirmModal(): void {
			this.$emit('decommissionGateway', this.gateway);
		},
	},
});
